import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpS = createBreakpoint('s');

export const mainCls = 'csa-slider-arrows';

export default {
  [mainCls]: {
    position: 'absolute',
    top: '50%',
    display: 'flex',
    alignItems: 'center',
    marginTop: '-24px',
    width: 48,
    height: 48,
    filter: 'drop-shadow(1px 2px 2px rgba(0,0,0,0.8))',
    cursor: 'pointer',
    '& svg': {
      width: 32,
      height: 32,
      pointerEvents: 'none',
    },    
    '&.next': {
      justifyContent: 'flex-end',
      right: 0,
    },

    [brpS]: {
      justifyContent: 'center',
      filter: 'drop-shadow(1px 2px 2px rgba(0,0,0,0.5))',
      '& svg': {
        width: 48,
        height: 48,
      },
    }
  },
};